export class PolylineOptions {

  public geodesic?: boolean;
  public clickable?: boolean;
  public fillColor?: string;
  public fillOpacity?: number;
  public strokeColor?: string;
  public strokeOpacity?: number;
  public strokeWeight: number;
  public symbol?: any;

}
